import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin, Phone, Instagram } from 'lucide-react';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import { trackWhatsAppClick, trackEmailClick } from '../utils/analytics';

const navigation = {
  main: [
    { name: 'Home', href: '/' },
    { name: 'Sobre', href: '/sobre' },
    { name: 'Serviços', href: '/servicos' },
    { name: 'Cases', href: '/cases' },
    { name: 'Blog', href: '/blog' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Contato', href: '/contato' },
  ],
  social: [
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/in/danieltavares',
      icon: Linkedin,
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/consultingtavares/',
      icon: Instagram,
    },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white relative">
      <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
        <nav className="-mx-5 -my-2 flex flex-wrap justify-center" aria-label="Footer">
          {navigation.main.map((item) => (
            <div key={item.name} className="px-5 py-2">
              <Link to={item.href} className="text-base text-gray-300 hover:text-white">
                {item.name}
              </Link>
            </div>
          ))}
        </nav>

        <div className="mt-8 flex justify-center space-x-6">
          {navigation.social.map((item) => (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gray-300"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </a>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 items-center">
          <div className="flex items-center space-x-3">
            <Mail className="h-5 w-5 text-gray-400" />
            <a href="mailto:contato@danielmtavares.com.br" className="text-gray-300 hover:text-white" onClick={() => trackEmailClick('footer')}>contato@danielmtavares.com.br</a>
          </div>
          <div className="flex items-center space-x-3">
            <Phone className="h-5 w-5 text-gray-400" />
            <a href="https://wa.me/5511964772277?text=Gostaria%20de%20saber%20mais%20sobre%20os%20serviços%20da%20Tavares%20Consulting" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white" onClick={() => trackWhatsAppClick('footer')}>(11) 96477-2277</a>
          </div>
          <div className="flex items-center space-x-3">
            <MapPin className="h-5 w-5 text-gray-400" />
            <span className="text-gray-300">São Paulo, SP</span>
          </div>
        </div>

        <p className="mt-8 text-center text-base text-gray-400">
          &copy; {new Date().getFullYear()} Tavares Consulting. Todos os direitos reservados.
        </p>

        {/* Botão flutuante do WhatsApp (usando react-floating-whatsapp) */}
        <FloatingWhatsApp
          phoneNumber="5511964772277"
          accountName="Tavares Consulting"
          chatMessage="Olá! Como posso ajudar você hoje? 😊"
          avatar="/images/logo.PNG"
          statusMessage="Responde normalmente em minutos"
          notification
          notificationDelay={60}
          allowEsc
          allowClickAway
          onClick={() => trackWhatsAppClick('floating_button')}
          chatboxStyle={{
            color: '#000',
            backgroundColor: '#fff'
          }}
          style={{
            color: '#000'
          }}
        />

        {/* CSS customizado para garantir texto legível no chat */}
        <style>{`
          .floating-whatsapp-chatbox input {
            color: #000 !important;
            background-color: #fff !important;
          }
          .floating-whatsapp-chatbox textarea {
            color: #000 !important;
            background-color: #fff !important;
          }
        `}</style>
      </div>
    </footer>
  );
} 